import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useIdleTimer } from "react-idle-timer";
import Cookies from "js-cookie";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Slide from "@material-ui/core/Slide";
import eventBus from "../../../utils/eventBus.utils";
import { useTranslation } from "react-i18next";
import isAuthenticated from "../../../utils/isAuthenticated";

const Transition = React.forwardRef(function Transition (props, ref) {
  return <Slide
    direction="up"
    ref={ref} {...props} />;
});

const AutoLogoutMessage = ({ authentication }) => {
  const { t, ready } = useTranslation("otherInterface", { useSuspense: false });

  const [modalData, setModalData] = useState({
    agreeButton: "OK",
    open: false,
    handler: null
  });

  const handleMessage = () => {
    window.location.href = "/";
  };

  const handleOnIdle = () => {
    eventBus.dispatch('autoLogoutEvent');
  };

  const handleClose = () => {
    setModalData({ ...modalData, open: false });
  };

  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: parseInt(process.env.REACT_APP_DEFAULT_AUTO_LOGOUT_TIME),
    onIdle: handleOnIdle,
    debounce: 500
  });

  useEffect(() => {
    eventBus.on("autoLogoutEvent", () => {
      if (isAuthenticated()) {
        Cookies.remove("token");
        setModalData({
          ...modalData,
          open: true,
          handler: () => handleMessage()
        });
      }
    });
    eventBus.remove("autoLogoutEvent");
  }, []);

  return (
    <>
      {modalData.open &&
      <Dialog
        open={modalData.open}
        TransitionComponent={Transition}
        disableBackdropClick={true}
        keepMounted
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">{t("autoLogout.title")}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {t("autoLogout.message")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              modalData.handler();
              handleClose();
            }}
            color="primary"
          >
            {modalData.agreeButton}
          </Button>
        </DialogActions>
      </Dialog>
      }
    </>
  );

};

export default AutoLogoutMessage;